<template>
  <CHeader>
    <CModal
      add-content-classes="bg-transparent border-0"
      :no-close-on-backdrop="true"
      :centered="true"
      :show.sync="modalStatus"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="closeBtnContainer" @click="changeModalStatus">
          <p class="closeButton">
            <img
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%"
            />
          </p>
        </div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
      <template #body-wrapper>
        <div class="modal-content tab widthLoginModal">
          <ul
            class="nav nav-tabs col-12"
            id="myTab"
            role="tablist"
            style="padding-right: 0px; background-color: transparent"
          >
            <li
              class="nav-item col-12"
              @click="signInTabFn()"
              style="padding-right: initial; padding-left: initial; border-bottom: 1px solid #cccccc"
            >
              <a
                class="nav-link active sign-in-inactive"
                id="profile-tab"
                data-toggle="tab"
                href="#signin"
                ref="signinBtn"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
                style="padding: 0px;"
              >
                <p class="text-wrapper">SIGN IN</p>
              </a>
            </li>
            <!--
            <li
              class="nav-item col-6"
              @click="signUpTabFn()"
              style="padding-right: initial; padding-left: initial"
            >
              <a
                class="nav-link sign-up-inactive"
                id="home-tab"
                data-toggle="tab"
                href="#signup"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                <p class="text-wrapper">SIGN UP</p>
              </a>
            </li>
            -->
          </ul>

          <div class="tab-content" id="myTabContent">
            <!--
            <div
              class="tab-pane fade"
              id="signup"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <SignUpComponent
                :changeModalStatus="changeModalStatus"
                @onRegistered="onRegistered"
              />
            </div>
 -->
            <div
              class="tab-pane fade show active"
              id="signin"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <SignInComponent :closeModal="closeModal" />
            </div>
          </div>
        </div>
      </template>
    </CModal>
    <CNavbar expandable="md" type="black" class="pb-0 pt-0 mb-0" color="white">
      <CNavbarBrand class="ml-2 mx-auto d-lg-none" to="/">
        <img src="@/assets/Asset 2@2x.png" height="30" />
      </CNavbarBrand>
      <CToggler in-header class="d-sm-none" @click="collapsed = !collapsed" />
      <CCollapse :show="collapsed" navbar>
        <CNavbarNav class="mr-auto">
          <CNavItem class="px-3 d-none d-lg-block" to="/">
            <img src="@/assets/Asset 2@2x.png" height="30" />
          </CNavItem>
          <!-- <CNavItem href="#" disabled>Disabled</CNavItem> -->
        </CNavbarNav>

        <!-- For Website 
        <div class="input-group" style="min-height: 35px">
          <input
            placeholder="SEARCH"
            class="input-group-search"
            v-model="searchInput"
          />
          <img
            src="@/assets/icons/Search.svg"
            class="iconsearch-invert"
            @click="sentSearchInput"
          />
        </div>-->

        <!-- Right aligned nav items -->
        <CNavbarNav class="ml-auto">
          <!-- For Website -->
          <CHeaderNavItem
            v-if="this.$store.getters['auth/userStatus'] && $store.getters['profile/getUserType'] == 10"
            class="mx-3"
          >
            <CHeaderNavLink to="/Learningprofile">
              <p class="mb-0 mt-2 learning-profile">LEARNING PROFILE</p>
            </CHeaderNavLink>
          </CHeaderNavItem>

          <CHeaderNavItem
            v-if="this.$store.getters['auth/userStatus'] && ($store.getters['profile/getUserType'] == 20 || $store.getters['profile/getUserType'] == 99)"
            class="mx-3"
          >
            <CHeaderNavLink to="/course-management/courses-overview" @click.native="goToAdminPage()">
              <p class="mb-0 mt-2 learning-profile">COURSE MANAGEMENT</p>
            </CHeaderNavLink>
          </CHeaderNavItem>

          <TheHeaderDropdownNotimessage />

          <!-- For Mobile -->
          <CCol style="margin-right: -2em" class="d-sm-none pl-0">
            <CForm inline>
              <CInput
                placeholder="SEARCH"
                class="input-group-drop mb-0"
                v-model="searchInput"
                size="sm"
              />
              <CButton
                color="link"
                size="sm"
                class="my-2 my-sm-0"
                type="submit"
              >
                <img
                  src="@/assets/icons/Search.svg"
                  class="iconsearch-invert-drop"
                  @click="sentSearchInput"
                />
              </CButton>
            </CForm>
          </CCol>

          <CCol
            style="margin-top: -0.8em"
            class="d-xl-none d-lg-none d-md-none pl-0 ml-1"
            v-if="this.$store.getters['auth/userStatus'] && $store.getters['profile/getUserType'] == 10"
          >
            <CHeaderNavLink to="/Learningprofile">
              <p to="/Learningprofile" class="learning-profile-drop">
                LEARNING PROFILE
              </p>
            </CHeaderNavLink>
          </CCol>

          <CCol
            style="margin-top: -0.8em"
            class="d-xl-none d-lg-none d-md-none pl-0 ml-1"
            v-if="this.$store.getters['auth/userStatus'] && ($store.getters['profile/getUserType'] == 20 || $store.getters['profile/getUserType'] == 99)"
          >
            <CHeaderNavLink to="/course-management/courses-overview" @click.native="goToAdminPage()">
              <p class="learning-profile-drop">COURSE MANAGEMENT</p>
            </CHeaderNavLink>
          </CCol>

          <CCol
            to="/Learningprofile"
            class="d-xl-none d-lg-none d-md-none pl-0 ml-1"
            v-on:click="accountManagement('am')"
            v-if="this.$store.getters['auth/userStatus']"
          >
            <p class="learning-profile-drop">ACCOUNT MANAGEMENT</p>
          </CCol>
          <CCol
            class="d-xl-none d-lg-none d-md-none pl-0 ml-1 text-left"
            @click="logout"
            v-if="this.$store.getters['auth/userStatus']"
          >
            <p class="learning-profile-drop">LOG OUT</p>
          </CCol>

          <CHeaderNavItem
            v-if="this.$store.getters['auth/userStatus'] === false"
            class="mx-2"
          >
            <CHeaderNavLink>
              <p
                @click="changeModalStatus"
                class="mb-0 sign-in"
                style="text-transform: uppercase"
              >
                sign in
              </p>
            </CHeaderNavLink>
          </CHeaderNavItem>
          <TheHeaderDropdownAccnt />
          <TheHeaderDropdownLang v-if="displayLangOption" />
        </CNavbarNav>
      </CCollapse>
    </CNavbar>
  </CHeader>
</template>

<script>
import TheHeaderDropdownNotimessage from "./TheHeaderDropdownNotimessage";
import TheHeaderDropdownNoti from "./TheHeaderDropdownNoti";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownLang from "./TheHeaderDropdownLang";
import SignInComponent from "../components/authentication/SignInComponent";
import TheAdminHeader from "../containers/admin/TheAdminHeader";
import SignUpComponent from "../components/authentication/SignUpComponent";
import { mapGetters } from "vuex";

export default {
  name: "TheHeader",
  data() {
    return {
      searchInput: "",
      signInTab: true,
      signUpTab: false,
      loginModal: false,
      showModal: false,
      allCourse: {},
      headerStatus: false,
      displayLangOption: false,
      collapsed: false,
    };
  },
  created() {
    let x = this.$store.getters["getChangingSidebarStatus"];
    this.$store.commit("auth/closeModalLogin");
    this.closeModal();
  },
  mounted() {
    this.displayLangOption = this.$store.getters["template/getLangOption"];
  },
  components: {
    TheHeaderDropdownNotimessage,
    TheHeaderDropdownNoti,
    TheHeaderDropdownAccnt,
    TheHeaderDropdownLang,
    SignInComponent,
    SignUpComponent,
    TheAdminHeader,
  },
  computed: {
    ...mapGetters({
      getLangOption: "template/getLangOption",
      modalStatus: "auth/authModal",
      headerStatusGetter: "getChangingSidebarStatus",
    }),
  },
  watch: {
    getLangOption: function (val) {
      this.displayLangOption = val;
    },
    headerStatusGetter: function (val) {
      this.headerStatus = val;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    accountManagement: function (signal) {
      this.$router.push({
        name: "MainProfile",
        params: {
          signal: signal,
        },
      });
    },
    onRegistered() {
      this.$refs.signinBtn.click();
    },
    onClickSearch() {
      this.$router.push("/SearchResult");
    },
    sentSearchInput() {
      this.$emit("search", this.searchInput);
      this.searchInput = "";
      this.$router.push("/SearchResult");
    },
    changeModalStatus: function () {
      this.$store.commit("auth/setStatusModal");
    },
    onNotice() {
      this.$router.push({
        name: "MainProfile",
        params: {
          signal: "no",
        },
      });
    },
    signInTabFn() {
      this.signInTab = true;
      this.signUpTab = false;
    },
    signUpTabFn() {
      this.signInTab = false;
      this.signUpTab = true;
    },
    openLoginModal() {
      this.loginModal = true;
    },
    closeModal() {
      this.loginModal = false;
    },
    goToAdminPage() {
      this.$store.commit("language/setChangingSidebar", true);
      this.$router.push("/course-management/courses-overview");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
#profile-tab {
  border: none !important;
}
.navbar {
  width: 100%;
}


.nav-link.active {
  background: none !important;
}

.input-group {
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 15.75rem;
  border-width: 0.063rem;
  border-style: none none solid none;
  color: #cccccc;
  /* margin-top: -2rem; */
}

.input-group-drop {
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-width: 0.063rem;
  border-style: none none solid none;
  color: #cccccc;
  /* margin-top: -2rem; */
}

::placeholder {
  color: black !important;
  opacity: 1;
  font-family: "Roboto";
}

.input-group-search {
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 14rem;
  border-style: none none solid none;
  border: 0;
  border-color: transparent;
  background-color: transparent;
  margin-bottom: -0.5em;
  /* margin-top: -2rem; */
}

.input-group-drop {
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-style: none none solid none;
  border: 0;
  border-color: transparent;
  background-color: transparent;
  /* margin-top: -2rem; */
}

.search {
  color: black;
  margin-top: 2;
  padding-bottom: 0;
  margin-bottom: 0;
}

.custom-input {
  border-style: none;
  outline: none !important;
  font-size: 1.25rem;
  margin-bottom: 0;
  /* width: 15rem - inputIconSize; */
}

.custom-input::placeholder {
  letter-spacing: 0.125rem;
  font-size: 14px;
  color: black;
  margin-bottom: 0;
}

.iconsearch-invert {
  width: 14px;
  color: #cccccc;
  filter: invert(50%);
  margin-top: 0.5em;
}

.iconsearch-invert-drop {
  width: 14px;
  color: black;
  margin-bottom: 15px;
}
.c-header {
  top: 0;
}
header {
  box-shadow: 0 4px 7px -2px rgba(0, 0, 0, 0.75);
}

.category {
  font-family: Roboto;
  color: black;
  font-size: 17.5px;
  font-weight: 400;
}

.learning-profile {
  color: black;
  font-family: "Roboto";
  font-size: 17.5px;
  font-weight: 400;
  padding-top: 0.1em;
}

.learning-profile-drop {
  color: black;
  font-family: "Roboto";
  font-weight: 500;
  margin-bottom: 0;
  padding-bottom: 5px;
}

.limit {
  height: 48px;
}

.icon-category {
  width: 20px;
}

.noti-bell {
  width: 25px;
}

.sign-in {
  color: black;
  font-family: "Roboto";
  font-size: 18px;
  font-weight: 500;
  margin-top: 0.5em;
}

/*  Login style*/
.sign-in-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.sign-in-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.sign-up-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.sign-up-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.text-wrapper {
  position: relative;
  color: #000000;
  width: 100%;
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  font-family: "Roboto", Medium;
}

.closeBtnContainer {
  margin-bottom: 0;
}

#app .container.button button {
  color: red !important;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

#info-block section {
  border-top: 1px solid white;
  text-align: center;
}

.file-marker > div {
  padding: 0 3px;
  margin-top: -0.9em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

a {
  text-decoration: none;
}

.nav-link {
  border: none;
}

.nav-tabs {
  border: none;
}

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.widthLoginModal {
  margin-left: 4vh;
  width: 420px;
  position: inherit;
  border: 0px;
  border-radius: 20px;
}

@media only screen and (max-width: 415px) {
  .widthLoginModal {
    margin: 0 auto;
    width: 85%;
  }
}

@media only screen and (max-width: 575px) {
  .input-group {
    display: none;
  }
  .form-inline {
    margin-left: 1.2em;
  }
  .sign-in {
    margin-left: 0.6em;
    margin-top: -0.5em;
    padding-bottom: 5px;
  }
  .learning-profile {
    display: none;
  }
  .learning-profile-drop {
    margin-left: 0.9em;
    margin-top: 0.2em;
    margin-bottom: 0;
  }
  .navbar {
    margin-bottom: 1em;
  }
  .iconsearch-invert-drop {
    margin-top: 1.1em;
  }
}
@media only screen and (min-width: 767px) {
  .form-inline {
    display: none;
  }
  .c-header-toggler-icon {
    display: none;
  }
  .sign-in {
    margin-left: 1.5em;
    margin-top: 0.5em;
  }
}
</style>
